import { memo } from 'react';

import { SearchSubSideNavPanel } from '~/components/v2/components/workspace/search-nav/SearchSubSideNavPanel';
import { WorkspaceSidebarSectionStoreContextProvider } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarSectionStoreContext';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export const SearchSubSideNav = memo(() => {
  return (
    <WorkspaceSidebarSectionStoreContextProvider
      defaultCollapsed
      storageKey={ZustandStorageKeys.WorkspaceSidebarSectionSearchAll}
    >
      <SearchSubSideNavPanel />
    </WorkspaceSidebarSectionStoreContextProvider>
  );
});

SearchSubSideNav.displayName = 'SearchSubSideNav';
